import { useEffect, useMemo, useRef, useState } from "react";
import { buildOptionVoteCounts, getIncreasedOptionIds } from "../lib/voteOptionCounts.js";

export { buildOptionVoteCounts, getIncreasedOptionIds };

export function useRealtimeOptionShake(market) {
  const [ticks, setTicks] = useState({});
  const previousMarketIdRef = useRef("");
  const previousCountsRef = useRef({});
  const marketId = String(market?.id || "");

  useEffect(() => {
    const options = Array.isArray(market?.options) ? market.options : [];

    if (!marketId) {
      previousMarketIdRef.current = "";
      previousCountsRef.current = {};
      setTicks({});
      return;
    }

    const nextCounts = buildOptionVoteCounts(options);

    if (previousMarketIdRef.current !== marketId) {
      previousMarketIdRef.current = marketId;
      previousCountsRef.current = nextCounts;
      setTicks({});
      return;
    }

    const increasedOptionIds = getIncreasedOptionIds(previousCountsRef.current, options);
    previousCountsRef.current = nextCounts;
    if (increasedOptionIds.length === 0) return;

    setTicks((previous) => {
      const next = { ...previous };
      for (const optionId of increasedOptionIds) {
        next[optionId] = (next[optionId] || 0) + 1;
      }
      return next;
    });
  }, [marketId, market?.options]);

  return useMemo(
    () => ({
      getShakeClass(optionId) {
        const key = String(optionId || "");
        return pickShakeClassByTick(ticks[key] || 0);
      }
    }),
    [ticks]
  );
}

export function pickShakeClassByTick(tick) {
  const value = Number(tick || 0);
  if (value <= 0) return "";
  return value % 2 === 0 ? "vote-shake-b" : "vote-shake-a";
}
